// extracted by mini-css-extract-plugin
module.exports = {"main":"dashshared_main__2LKvR","topbar":"dashshared_topbar__3snuu","content":"dashshared_content__blMCn","bell":"dashshared_bell__APRzW","toggle":"dashshared_toggle__2BSYk"};